export const siteConfig = {
  email: "monir@monirhrabby.com",
};
